const isValidEmail = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  const [localPart, domainPart, ...rest] = value.split('@');
  if (!localPart || !domainPart || rest.length > 0) {
    return false;
  }

  const domainLabels = domainPart.split('.');
  if (domainLabels.length < 2) {
    return false;
  }

  return domainLabels.every(
    (label) => label.length > 0 && !label.includes(' '),
  );
};

export const emailRegex = {
  test: isValidEmail,
  [Symbol.match]: (value) => (isValidEmail(value) ? [value] : null),
};

export const phoneRegex = /^06\d{8}/gi;

export const DIALOG_FOOTER_HEIGHT_IN_PX = 50;
export const DIALOG_HEADER_HEIGHT_IN_PX = 64;
